import React from "react";
import PropTypes from "prop-types";
import Input from "../Input/Input";
import classnames from "classnames";
import css from "./styles.less";
import { isMobileDevice } from "../common/utils.js";

class Advanced extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			boxVisible: this.props.isPromoCodeBoxVisible
		};
	}

	toggleVisible = () => {
		var newBoxVisbleState = !this.state.boxVisible;
		this.setState({ boxVisible: newBoxVisbleState });
		if (newBoxVisbleState && isMobileDevice()) {
			document.addEventListener("click", this.hide);
		}
	};

	hide = event => {
		const elm = this.toolBoxHolder;
		if (elm && elm.contains(event.target)) {
			return false;
		}
		this.setState({ boxVisible: false });
		if (isMobileDevice()) {
			document.removeEventListener("click", this.hide);
		}
	};

	render() {
		const {
			titleStyle,
			direction,
			titles,
			enablePromoCode,
			enableAgentLogin,
			LoginLink,
			promoCode,
			onChangePromoCode,
			isLocked
		} = this.props;

		var styles = {
			title: titleStyle
		};

		return (
			<div className={classnames(css.advanced, css[direction])}>
				<div className={css.advancedTitle} onClick={this.toggleVisible}>
					<span className={css.theTitle}>{titles.CouponCode}</span>
					<span
						className={`glyphicon glyphicon-triangle-bottom ${css.iconHolder}`}
					/>
				</div>
				<div
					className={classnames(
						css.toolboxHolder,
						this.state.boxVisible && css.show
					)}
					ref={ref => (this.toolBoxHolder = ref)}
				>
					<div
						className={classnames(
							css.toolbox,
							"sbox__toolbox",
							this.props.isLocked ? css.isLocked : ""
						)}
					>
						{enablePromoCode && (
							<div className={css.promoHolder}>
								{/* <div className={css.promoLabel}>
                                    <span>{titles.PromoCodeTitle}</span>
                                </div> */}
								<Input
									//{...this.props}
									placeHolder={titles.CouponCode}
									value={promoCode || ""}
									onChange={onChangePromoCode}
									isLocked={isLocked}
								/>
							</div>
						)}

						{/* {enableAgentLogin &&
                            <div className={css.loginLinkHolder}>
                                <a href={LoginLink}>{titles.Login}</a>
                            </div>} */}
					</div>
				</div>
			</div>
		);
	}
}

Advanced.propTypes = {
	titleStyle: PropTypes.object,
	direction: PropTypes.oneOf(["left", "right"]),
	searchBoxStyle: PropTypes.object,
	isRounded: PropTypes.bool,
	promoCode: PropTypes.string,
	onChangePromoCode: PropTypes.func,
	config: PropTypes.object,
	enablePromoCode: PropTypes.bool,
	enableAgentLogin: PropTypes.bool,
	LoginLink: PropTypes.string,
	titles: PropTypes.object,
	isPromoCodeBoxVisible: PropTypes.bool,
	isLocked: PropTypes.bool
};

Advanced.defaultProps = {
	titles: {
		Advanced: "Advanced",
		Login: "Login",
		PromoCodeTitle: "Promo Code",
		PromoCodePlaceHolder: "Promo Code"
	},
	enablePromoCode: true,
	enableAgentLogin: true,
	LoginLink: "/inserLoginLink.html",
	isRounded: false,
	promoCode: "",
	isPromoCodeBoxVisible: false
};

export default Advanced;



// WEBPACK FOOTER //
// ./src/components/Advanced/Advanced.js